import { HStack, Text, VStack } from '@ayble-health/dashboard-components';
import { Box } from '@chakra-ui/react';
import { TooltipProps } from 'recharts';
import {
  NameType,
  ValueType,
} from 'recharts/types/component/DefaultTooltipContent';

interface ITooltipProps extends TooltipProps<ValueType, NameType> {
  payload?: any;
}

export const TimeChartTooltip = ({ active, payload }: ITooltipProps) => {
  if (!active || !payload?.length) return null;

  return (
    <VStack
      bgColor={'white'}
      borderColor={'cloud.200'}
      borderWidth={1}
      justifyContent={'space-around'}
      p={2}
      rounded={'lg'}
    >
      <Text
        color={'secondary.500'}
        fontSize={'xs'}
        fontWeight={'normal'}
        mb={1}
      >
        {payload?.[0]?.payload.formattedDate}
      </Text>

      {payload.map(({ color, name, value }, i) => (
        <HStack key={`${name}-${i}`} alignItems={'center'}>
          <Box
            bgColor={color}
            h={'9px'}
            mt={0.5}
            mr={1}
            rounded={'full'}
            w={'9px'}
          />
          <Text
            color={'secondary.500'}
            fontSize={'xs'}
            fontWeight={'normal'}
            key={i}
          >
            {name}: {value}
          </Text>
        </HStack>
      ))}
    </VStack>
  );
};
